import { ChangePasswordComponent } from './../modules/components/change-password/change-password.component';
import { ContactUsComponent } from './../modules/components/contact-us/contact-us.component';
import { LoginComponent } from './../modules/components/login/login.component';
import { Injectable } from '@angular/core';
import { ToastController, AlertController, LoadingController, ModalController } from '@ionic/angular';
import { AlertButton, AlertInput } from '@ionic/core';

@Injectable({
  providedIn: 'root'
})
export class CommonMessageService {

  constructor(public toastController: ToastController,
    public alertController: AlertController,
    private modalController: ModalController,
    public loadingController: LoadingController) { }

  async toast(message, duration = 2500, closeButton = '', error = false, position: 'top' | 'bottom' | 'middle' = 'top') {
    const toast = await this.toastController.create({
      message: message,
      duration,
      closeButtonText: closeButton,
      showCloseButton: !!closeButton,
      animated: true,
      color: error ? 'danger' : 'success',
      cssClass: error ? 'danger' : 'success',
      mode: 'ios',
      position,
      id: '' + new Date().getTime()
    });
    toast.present();
    return toast;
  }
  async errorToast(message, duration = 3000, closeButton = 'Fermer') {
    return this.toast(message, duration, closeButton, true, 'top');
  }
  async successToast(message, duration = 3000) {
    return this.toast(message, duration);
  }
  
  async alert(message, title, subTitle, buttons: (AlertButton | string)[] = ['Ok'], inputs: AlertInput[] = []) {
    const alert = await this.alertController.create({
      header: title,
      subHeader: subTitle,
      message: message,
      buttons,
      inputs
    });
    await alert.present();
    return alert;
  }
  async loading(message, duration = -1) {
    const loading = await this.loadingController.create({
      message: message,
      cssClass: 'primary',
      animated: true,
      mode: 'ios',
      spinner: 'bubbles',
    });
    if (duration > 0) {
      loading.duration = duration;
    }
    await loading.present();
    return loading;
  }

}
